import { Link } from "react-router";
import { paths } from "@shared-core/routing/routes";
import { Button } from "../app/components/primitives/button";
import { Card } from "../app/components/primitives/card";
import { SupplierHeader } from "./shell/SupplierHeader";
import { useNotFoundWhy } from "./shell/staffView";
import { EmptyState } from "./shell/states";

/** Any path the portal doesn't have. */
export function NotFoundPage() {
  // Staff did not come from an order email: they are told whose orders the portal is showing.
  const whyNotFound = useNotFoundWhy(
    "order",
    "If you came from an order email, please open its link again.",
  );
  return (
    <div className="min-h-screen bg-muted/30">
      <SupplierHeader right={null} />
      <main className="mx-auto max-w-5xl px-4 py-5 sm:px-6">
        <Card>
          <EmptyState
            title="We can't find this page"
            action={
              <Button asChild variant="outline">
                <Link to={paths.supplierOrders()}>Your orders</Link>
              </Button>
            }
          >
            <p>{whyNotFound}</p>
          </EmptyState>
        </Card>
      </main>
    </div>
  );
}
